import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import InlineList from 'components/InlineList';
import FormField, { useFormFieldContext } from 'components/FormField';
import BadgeImage from 'components/BadgeImage';
import BadgeImagePickerModal from 'screens/BadgeImagePickerModal';
import AddOrEditButton from './AddOrEditButton';
var BadgeField = function BadgeField(_ref) {
  var _ref$horizontal = _ref.horizontal,
    horizontal = _ref$horizontal === void 0 ? true : _ref$horizontal,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'transparent' : _ref$variant,
    badge = _ref.badge,
    _onChange = _ref.onChange,
    parentPlaylistId = _ref.parentPlaylistId,
    isDisabled = _ref.isDisabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId();
  var _useFormFieldContext = useFormFieldContext(),
    labelId = _useFormFieldContext.labelId;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isBadgeImageEditorOpen = _useState2[0],
    setBadgeImageEditorOpen = _useState2[1];
  var hasBadge = !!(badge && !badge.isDeleted && badge.imageId);
  return /*#__PURE__*/React.createElement(FormField, {
    as: "span",
    label: t('content_type_badge'),
    labelId: uniqueId,
    horizontal: horizontal
  }, /*#__PURE__*/React.createElement(InlineList, {
    spacing: "xxs",
    "aria-labelledby": labelId,
    align: "middle"
  }, hasBadge && badge.pictureUrl && /*#__PURE__*/React.createElement(BadgeImage, {
    src: badge === null || badge === void 0 ? void 0 : badge.pictureUrl,
    alt: badge === null || badge === void 0 ? void 0 : badge.imageAlternativeText,
    variant: badge === null || badge === void 0 ? void 0 : badge.style
  }), /*#__PURE__*/React.createElement(AddOrEditButton, {
    isEditMode: hasBadge,
    addText: t('actions_add_badge'),
    editText: t('actions_edit_badge'),
    variant: variant,
    onClick: function onClick() {
      return setBadgeImageEditorOpen(true);
    },
    isDisabled: isDisabled
  })), isBadgeImageEditorOpen && /*#__PURE__*/React.createElement(BadgeImagePickerModal, {
    parentPlaylistId: parentPlaylistId,
    initialSelectedBadgeImage: hasBadge && badge.imageId ? {
      imageId: Number(badge === null || badge === void 0 ? void 0 : badge.imageId),
      style: badge === null || badge === void 0 ? void 0 : badge.style,
      imageAlternativeText: badge === null || badge === void 0 ? void 0 : badge.imageAlternativeText,
      pictureUrl: badge === null || badge === void 0 ? void 0 : badge.pictureUrl
    } : null,
    onChange: function onChange(badgeImageChanges) {
      if (
      // A badge  was deleted
      badgeImageChanges === null && badge !== null && badge !== void 0 && badge.id) {
        _onChange({
          id: badge.id,
          imageId: null
        });
      } else if (
      // A badge was added or edited
      badgeImageChanges !== null) {
        _onChange(_objectSpread(_objectSpread(_objectSpread({}, badge), badgeImageChanges), {}, {
          isDeleted: false
        }));
      }
    },
    onClose: function onClose() {
      return setBadgeImageEditorOpen(false);
    }
  }));
};
export default BadgeField;